import { render, staticRenderFns } from "./UniversityLessonVideoModal.vue?vue&type=template&id=6997ee5e&scoped=true&"
import script from "./UniversityLessonVideoModal.vue?vue&type=script&lang=js&"
export * from "./UniversityLessonVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./UniversityLessonVideoModal.vue?vue&type=style&index=0&id=6997ee5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997ee5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VProgressLinear})
